import DeviceSessions from '@/apps/account/devices/DeviceSessions.vue';
import { requireAuthenticated } from '../guards/authGuards';
import combineGuards from '../guards/helpers';

const deviceSessionsRoutes = [
  {
    path: '/account/devices',
    name: 'DeviceSessions',
    component: DeviceSessions,
    meta: {
      robots: 'noindex, nofollow',
    },
    beforeEnter: combineGuards([requireAuthenticated]),
  },
];

export default deviceSessionsRoutes;
